import { render, staticRenderFns } from "./asset-ficha.vue?vue&type=template&id=370ba4f8&scoped=true&"
import script from "./asset-ficha.vue?vue&type=script&lang=js&"
export * from "./asset-ficha.vue?vue&type=script&lang=js&"
import style0 from "./asset-ficha.vue?vue&type=style&index=0&id=370ba4f8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370ba4f8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VRow,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('370ba4f8')) {
      api.createRecord('370ba4f8', component.options)
    } else {
      api.reload('370ba4f8', component.options)
    }
    module.hot.accept("./asset-ficha.vue?vue&type=template&id=370ba4f8&scoped=true&", function () {
      api.rerender('370ba4f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/details-asset/asset-ficha.vue"
export default component.exports